import React from "react";
import { Box, IconButton, Paper, Stack, Typography } from "@mui/material";
import ExpandMoreRounded from "@mui/icons-material/ExpandMoreRounded";
import LightbulbOutlined from "@mui/icons-material/LightbulbOutlined";

/**
 * Collapsed-by-default Clinical Hints control (Exam2 "Findings to look for" parallel).
 * Hints render under matching *2 rows when expanded; optional unmapped tips list here.
 *
 * dense: compact card for the Mark All toolbar row (right-aligned with the table).
 */
const Plan2HintsPanel = ({
  open,
  onToggle,
  hasHints = false,
  otherTips = [],
  dense = false,
  sx,
}) => {
  if (!hasHints) return null;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: dense ? 1.5 : 2,
        mb: dense ? 0 : 3,
        textAlign: "left",
        ...(dense ? { maxWidth: 360, width: "100%" } : null),
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <LightbulbOutlined color="action" fontSize="small" />
          <Typography variant="subtitle1">Clinical Hints</Typography>
        </Box>
        <IconButton
          size="small"
          aria-label={open ? "Hide clinical hints" : "Show clinical hints"}
          aria-expanded={open}
          onClick={onToggle}
          sx={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: (theme) =>
              theme.transitions.create("transform", {
                duration: theme.transitions.duration.shortest,
              }),
          }}
        >
          <ExpandMoreRounded />
        </IconButton>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {open
          ? "Hints are shown under each item."
          : "Expand to show hints under each item."}
      </Typography>
      {open && otherTips.length > 0 ? (
        <Stack spacing={0.75} sx={{ mt: 1.5 }}>
          <Typography variant="subtitle2">Other</Typography>
          {otherTips.map((tip) => (
            <Typography
              key={tip.examName || tip.line || tip.name}
              variant="body2"
              color="text.secondary"
            >
              {tip.line ||
                `${tip.examName || tip.name || ""}${
                  tip.lookFor?.length
                    ? `: ${tip.lookFor.join("; ")}`
                    : tip.rationale
                      ? `: ${tip.rationale}`
                      : ""
                }${tip.diagnoses?.length ? ` (${tip.diagnoses.join(", ")})` : ""}`}
            </Typography>
          ))}
        </Stack>
      ) : null}
    </Paper>
  );
};

export default Plan2HintsPanel;
